/**
 * ScenarioAiButton Component
 * 
 * Floating action button to open the Scenario AI Assistant.
 * Follows the same visual style as UnifiedAiButton but opens ScenarioChatbot.
 */

import React from 'react';
import { Tooltip } from 'antd';
import './scenario-ai-button.css';

const ScenarioAiButton = ({
  isOpen,
  onClick,
}) => {
  return (
    <Tooltip
      title="Scenario AI Assistant"
      placement="left"
    >
      <button
        className={`scenario-ai-button ${isOpen ? 'active' : ''}`}
        onClick={onClick}
        aria-label="Open Scenario AI Assistant"
      >
        {isOpen ? (
          <span className="scenario-ai-button-icon" style={{ fontSize: '28px' }}>×</span>
        ) : (
          <svg
            className="scenario-ai-button-icon"
            width="26"
            height="26"
            viewBox="0 0 26 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M8.17266 4.31878L6.34833 3.71067L5.74022 1.88634C5.54233 1.297 4.56733 1.297 4.36944 1.88634L3.76133 3.71067L1.93699 4.31878C1.64233 4.417 1.44299 4.69289 1.44299 5.00345C1.44299 5.314 1.64233 5.58989 1.93699 5.68811L3.76133 6.29623L4.36944 8.12056C4.46766 8.41523 4.74499 8.61456 5.05555 8.61456C5.3661 8.61456 5.64199 8.41523 5.74166 8.12056L6.34977 6.29623L8.1741 5.68811C8.46877 5.58989 8.6681 5.314 8.6681 5.00345C8.6681 4.69289 8.46733 4.417 8.17266 4.31878Z" fill="currentColor"/>
            <path d="M13.7222 3.97217L16.4839 10.9589L23.4722 13.7222L16.4839 16.4854L13.7222 23.4722L10.9589 16.4854L3.97217 13.7222L10.9589 10.9589L13.7222 3.97217Z" stroke="currentColor" strokeWidth="1.73333" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        )}
      </button>
    </Tooltip>
  );
};

export default ScenarioAiButton;
